jQuery.extend(jQuery.validator.messages, {
	required: jserrorvalidationrequired,
	remote: msgGeneralWarnRemote,
	email: jserrorvalidationemail,
	url: msgGeneralWarnUrl,
	date: msgGeneralWarnDate,
	dateISO: msgGeneralWarnDateISO,
	number: msgGeneralWarnNumber,
	digits: msgGeneralWarnDigits,
	creditcard: msgGeneralWarnCreditCard,
	equalTo: msgGeneralWarnEqualTo,
	accept: msgGeneralWarnAccept,
	maxlength: jQuery.validator.format(jserrorvalidationmaxlength),
	minlength: jQuery.validator.format(jserrorvalidationminlength),
	rangelength: msgGeneralWarnRangeLength,
	range: msgGeneralWarnRange,
	max: msgGeneralWarnMax,
	min: msgGeneralWarnMin,
	tcno: msgGeneralWarnTcno,
	tripleDateBoundries: "",
	doubleDateBoundries: "",
	gsm: msgGeneralWarnGsm,
	cc_owner_name : msgCCNameWarm,
	cvc_warn : msgCVCWarn,
	gender_warn : msgGenderWarn,
	passNo_warn : msgPassNoWarn,
	cc_expire_month_warn : msgCCExpireMonthWarn,
	cc_expire_year_warn : msgCCExpireYearWarn,
	busNameLength : msgBusNameLengthWarn,
    minlengthspace: jQuery.validator.format(jserrorvalidationminlengthspace),
    pattern: jserrorinvalidformat
//	,metasearchCardBrandFee : msgMetasearchCardBrandFee
});

function getFmtMessagesWithArgs(s){
	var i = arguments.length;
	while (i > 0) {
		i--;
	    s = s.replace(new RegExp('\\{' + (i-1) + '\\}', 'gm'), arguments[i]);
	}
	return s;
};